var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [(_vm.listProjectData.length > 0) ? _c('fieldset', [_c('legend', [_vm._v("User Application Access Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-md-12 "
  }, [_c('div', {
    staticClass: "col-md-6 float-md-left "
  }, [_c('label', [_vm._v("Project Name")])])]), _vm._v(" "), _vm._l((_vm.listProjectData), function(project_obj, index) {
    return _c('div', {
      staticClass: "row col-md-12 float-md-left wrapper_form"
    }, [_c('div', {
      staticClass: "projitemlist",
      attrs: {
        "id": 'projectlistitem_' + project_obj.project.projectid,
        "show": "0"
      },
      on: {
        "click": function($event) {
          _vm.showProjectName(project_obj.project.projectid)
        }
      }
    }, [_vm._v(_vm._s(project_obj.project.projectname)), _c('i', {
      staticClass: "fa fa-angle-right fa-lg arrow_item",
      attrs: {
        "id": 'arrow_' + project_obj.project.projectid,
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('form', {
      staticClass: "form-group col-md-12 hideProject access_form",
      attrs: {
        "id": 'projectaccess_' + project_obj.project.projectid
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.onSubmit(project_obj.project.projectid)
        }
      }
    }, [_c('div', {
      staticClass: "col-md-12 float-md-left"
    }, [_c('div', {
      staticClass: "col-md-2 float-md-left "
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.projectidchk[project_obj.project.projectid]),
        expression: "form.projectidchk[project_obj.project.projectid]"
      }],
      class: {
        'error': _vm.errors.has('projectid')
      },
      staticStyle: {
        "font-weight": "100"
      },
      attrs: {
        "type": "checkbox",
        "name": "projectid",
        "id": project_obj.project.projectid
      },
      domProps: {
        "value": _vm.form.projectidchk[project_obj.project.projectid],
        "checked": Array.isArray(_vm.form.projectidchk[project_obj.project.projectid]) ? _vm._i(_vm.form.projectidchk[project_obj.project.projectid], _vm.form.projectidchk[project_obj.project.projectid]) > -1 : (_vm.form.projectidchk[project_obj.project.projectid])
      },
      on: {
        "change": function($event) {
          _vm.validateRole(project_obj.project.projectid, $event);
        },
        "__c": function($event) {
          var $$a = _vm.form.projectidchk[project_obj.project.projectid],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.form.projectidchk[project_obj.project.projectid],
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.form.projectidchk[project_obj.project.projectid] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.form.projectidchk[project_obj.project.projectid] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.form.projectidchk, project_obj.project.projectid, $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(project_obj.project.projectname)), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 float-md-left"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.projectidwiserole[project_obj.project.projectid]),
        expression: "form.projectidwiserole[project_obj.project.projectid]"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true, 'error': _vm.errors.has('projectroleid' + project_obj.project.projectid)
      },
      attrs: {
        "name": _vm.setname(project_obj.project.projectid),
        "id": _vm.setname(project_obj.project.projectid),
        "disabled": _vm.bindroleid(project_obj.project.projectid) == '' ? true : false
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.form.projectidwiserole, project_obj.project.projectid, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.removeValidation('projectroleid' + project_obj.project.projectid, project_obj.roles, project_obj.project.projectid)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "selected": ""
      }
    }, [_vm._v("Select Role")]), _vm._v(" "), _vm._l((project_obj.roles), function(role_obj) {
      return _c('option', {
        domProps: {
          "value": role_obj.roleid
        }
      }, [_vm._v(_vm._s(role_obj.rolename))])
    })], 2), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('projectroleid' + project_obj.project.projectid)),
        expression: "errors.has('projectroleid'+project_obj.project.projectid)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select default role.")])]), _vm._v(" "), (_vm.userDetails.utype == '2') ? _c('div', {
      staticClass: "col-md-3 float-md-left"
    }, [_c('multiselect', {
      class: {
        'form-control': true, 'error': _vm.errors.has('projectmultiroleid' + project_obj.project.projectid)
      },
      attrs: {
        "options": project_obj.roles,
        "multiple": true,
        "placeholder": "Select multiple roles",
        "track-by": "rolename",
        "label": "rolename",
        "disabled": _vm.bindroleid(project_obj.project.projectid) == '' ? true : false,
        "name": _vm.setrolename(project_obj.project.projectid),
        "hide-selected": true,
        "id": _vm.setrolename(project_obj.project.projectid)
      },
      model: {
        value: (_vm.form.projectidwisemultirole[project_obj.project.projectid]),
        callback: function($$v) {
          _vm.$set(_vm.form.projectidwisemultirole, project_obj.project.projectid, $$v)
        },
        expression: "form.projectidwisemultirole[project_obj.project.projectid]"
      }
    }, [_c('span', {
      slot: "noResult"
    }, [_vm._v("Oops! No elements found. Consider changing the search query.")])]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('projectmultiroleid' + project_obj.project.projectid)),
        expression: "errors.has('projectmultiroleid'+project_obj.project.projectid)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select multiple role.")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 float-md-left"
    }, [_c('multiselect', {
      class: {
        'error': _vm.errors.has('projecthubzoneid' + project_obj.project.projectid)
      },
      attrs: {
        "options": _vm.listHubZoneData,
        "multiple": true,
        "placeholder": "Type to search",
        "track-by": "hubzonename",
        "label": "hubzonename",
        "name": _vm.sethubzonename(project_obj.project.projectid),
        "id": _vm.sethubzonename(project_obj.project.projectid),
        "value": "project_obj.project.projectid",
        "hide-selected": true,
        "disabled": _vm.bindroleid(project_obj.project.projectid) == '' ? true : false
      },
      on: {
        "input": _vm.getHublistOfZone,
        "remove": _vm.removeHubs
      },
      model: {
        value: (_vm.form.projectidwisezone[project_obj.project.projectid]),
        callback: function($$v) {
          _vm.$set(_vm.form.projectidwisezone, project_obj.project.projectid, $$v)
        },
        expression: "form.projectidwisezone[project_obj.project.projectid]"
      }
    }, [_c('span', {
      slot: "noResult"
    }, [_vm._v("Oops! No elements found. Consider changing\n                            the search query.")])]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('projecthubzoneid' + project_obj.project.projectid)),
        expression: "errors.has('projecthubzoneid'+project_obj.project.projectid)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select zone.")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 float-md-left"
    }, [_c('multiselect', {
      class: {
        'error': _vm.errors.has('projecthubid' + project_obj.project.projectid)
      },
      attrs: {
        "options": _vm.listHubsData,
        "multiple": true,
        "placeholder": "Type to search",
        "track-by": "HubName",
        "label": "HubName",
        "disabled": _vm.bindroleid(project_obj.project.projectid) == '' ? true : false,
        "name": _vm.sethubname(project_obj.project.projectid),
        "id": _vm.sethubname(project_obj.project.projectid)
      },
      model: {
        value: (_vm.form.projectidwisehubs[project_obj.project.projectid]),
        callback: function($$v) {
          _vm.$set(_vm.form.projectidwisehubs, project_obj.project.projectid, $$v)
        },
        expression: "form.projectidwisehubs[project_obj.project.projectid]"
      }
    }, [_c('span', {
      slot: "noResult"
    }, [_vm._v("Oops! No elements found. Consider changing the search query.")])]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('projecthubid' + project_obj.project.projectid)),
        expression: "errors.has('projecthubid'+project_obj.project.projectid)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select hubs.")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12 float-md-left"
    }, [_c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "type": "submit",
        "size": "vlg"
      }
    }, [_vm._v("Save")])])])])
  })], 2)])]) : _vm._e()])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bcddc50","hasScoped":true}!./src/views/components/accessprojects/accessprojects.component.html
// module id = 831
// module chunks = 1